import { render, staticRenderFns } from "./BrandNavigation.vue?vue&type=template&id=3ba1f840&scoped=true"
import script from "./BrandNavigation.vue?vue&type=script&lang=js"
export * from "./BrandNavigation.vue?vue&type=script&lang=js"
import style0 from "./BrandNavigation.vue?vue&type=style&index=0&id=3ba1f840&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba1f840",
  null
  
)

export default component.exports